import React, { useState, useEffect } from 'react';
import './CookieConsent.scss';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consentStatus = localStorage.getItem('cookieConsent');
    if (!consentStatus) {
      // Only show if no previous choice was made
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__container">
        <div className="cookie-consent__content">
          <h3>Cookie Policy</h3>
          <p>
            We use cookies to enhance your experience on our website. By continuing to browse, you agree to our use of cookies.
            You can learn more about how we use cookies in our <a href="/privacy-policy">Privacy Policy</a>.
          </p>
        </div>
        <div className="cookie-consent__actions">
          <button 
            className="cookie-consent__button cookie-consent__button--accept" 
            onClick={handleAccept}
          >
            Accept
          </button>
          <button 
            className="cookie-consent__button cookie-consent__button--decline" 
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
